export default "__VITE_ASSET__DWiABtTs__"